import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	selectedLabel: {
		id: 'jql-builder-basic-picker.async-select.selected-label',
		defaultMessage: 'Selected',
		description: 'Label for the selected options group',
	},
});

export default messages;
